import { styled } from '../../theme'

export const Container = styled.div`
  max-width: ${p => p.theme.grid.contentMaxWidth}px;

  margin-left: auto;
  margin-right: auto;
`
